import { GET_BAG } from "./constants";

const subscribeToUpdates = dispatch => {
  //Use the jQuery existant on the window instead of the bundled one
  //eslint-disable-next-line no-undef
  $(window.__sdk.bag).on("bagUpdated:completed", (...args) => {
    const { bag, messages } = args[2];
    dispatch({
      type: GET_BAG,
      payload: { bag: { ...bag, isUpdated: true }, messages }
    });
  });
};

const getBagSummary = dispatch =>
  window.__sdk.bag
    .getBagSummary()
    .then(summary => dispatch({ type: GET_BAG, payload: { bag: { summary } } }))
    .catch(e => dispatch({ type: GET_BAG, error: true, payload: e }));

const waitForBagSDK = () =>
  new Promise(resolve => {
    if (window.__sdk && window.__sdk.bag) {
      return resolve();
    }
    window.analyticsEventEmitter.addListener("sdk-ready", resolve);
  });

export const getBagFromSDK = () => dispatch =>
  new Promise(function(resolve) {
    waitForBagSDK().then(() => {
      subscribeToUpdates(dispatch);
      resolve(getBagSummary(dispatch));
    });
  });



// WEBPACK FOOTER //
// ./template/state/modules/miniBag/actions.js